export const SiteFooter = () => (
  <footer className="border-t border-white/10 bg-[#070a12] py-12 font-mono-lbl text-xs text-slate-500" data-testid="site-footer">
    <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-6 px-6 md:flex-row">
      <div className="flex items-center gap-3">
        <span className="font-disp text-lg text-white">EL &amp; MJ TRAVEL</span>
        <span>&middot;</span>
        <span>Leeds Bradford &amp; North Regional Airports</span>
      </div>
      <div>
        <span>Fixed Rates &bull; Licensed Private Hire</span>
      </div>
    </div>
  </footer>
);
